import { Component, type ReactNode } from "react";
import { Button } from "@opencloud/ui";
import { agentBrand } from "../brand.js";

/**
 * Keeps a render failure from blanking the whole Agent. The React root
 * reports the error to the platform issue tracker.
 */
export class AppErrorBoundary extends Component<
  { children: ReactNode },
  { failed: boolean }
> {
  state = { failed: false };

  static getDerivedStateFromError() {
    return { failed: true };
  }

  render() {
    if (!this.state.failed) return this.props.children;
    const brand = agentBrand();
    return (
      <main className="agent-crash" role="alert">
        <h1>{brand.agentName} hit a problem</h1>
        <p>
          This page could not be displayed, and the {brand.productName} team
          has been told. Your conversation is saved; reload to continue.
        </p>
        <Button onClick={() => window.location.reload()}>Reload</Button>
      </main>
    );
  }
}
